import { ApexOptions } from "apexcharts"
import { useMemo } from "react"
import ReactApexChart from "react-apexcharts"
import { ApexChartType } from "src/shared/config/DefaultApexOptions"
import { monitorApexOptions } from "../../../chartDateAxis"

export const RevenueByDay = ({ series }: ApexOptions) => {
  const revenueByDayOptions = useMemo<ApexOptions>(
    () => monitorApexOptions({
      yaxis: {
        labels: {
          formatter: function (y) {
            return `$${y.toFixed(0)}`
          },
        },
      },
    }, ApexChartType.bar),
    [],
  )

  return (
    <div>
      <ReactApexChart
        options={revenueByDayOptions}
        series={series}
        type="bar"
        height={400}
      />
    </div>
  )
}
